module.exports = __webpack_public_path__ + "static/media/icon-exclamation.35cb1bc3.svg";